module.exports = __webpack_public_path__ + "static/media/icon_search.17f33069.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/search/icon_search.svg
// module id = 347
// module chunks = 0